// eslint-disable-next-line no-use-before-define
import React, { PureComponent } from 'react';
import ImageLinks from 'utils/ImageLinks';
import InputWithIcon from 'components/Input/InputWithIcon';
import HighlightButton from 'components/Button/HighlightButton';
import request from 'utils/request';
import LoadingSpinner from 'components/LoadingSpinner';
import 'features/internal-users/user/Login/Login.scss';
import { withTranslation } from 'react-i18next';
import { TRANSLATIONS } from 'types/enums';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { userOnlyHasAccessToReportSIOs, userOnlyHasAccessToSearchUserScreen } from 'utils/shared/canUserAccessFeature';
import ButtonWithIconAndText from 'components/Button/ButtonWithIconAndText';
import withNavigation from 'utils/hoc/withNavigation';
import { isUserAuthenticated } from 'store/actions/user.actions';

const LockIcon = ImageLinks.lockIcon;
const UserIcon = ImageLinks.userIcon;
const UserWarningIcon = ImageLinks.userWarningIcon;
const LockIWarningIcon = ImageLinks.lockWarningIcon;
const EyeIcon = ImageLinks.eyex2;

const MicrosoftIcon = ImageLinks.microsoft;

type State = {
  email: string;
  password: string;
  errors: any;
  loggingIn: boolean;
};

class Login extends PureComponent<any, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      email: '',
      password: '',
      errors: {},
      loggingIn: false,
    };
    this.submitLogin = this.submitLogin.bind(this);
    this.submitLoginSSO = this.submitLoginSSO.bind(this);
    // this.logoutSSO = this.logoutSSO.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.enterSubmit = this.enterSubmit.bind(this);
  }

  componentDidUpdate(prevProps : any) {
    if (!prevProps.user?.email && this.props.user?.email) {
      if (userOnlyHasAccessToSearchUserScreen(this.props.user?.type)) {
        this.props.navigate('/users-blocked', { replace: true });
        return;
      }
      if (userOnlyHasAccessToReportSIOs(
        this.props.user?.features,
        this.props.user,
      )) {
        this.props.navigate('/ac', { replace: true });
        return;
      }
      this.props.navigate('/', { replace: true });
    }
  }

  enterSubmit(e: React.KeyboardEvent<HTMLFormElement>) {
    if (e.keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      this.submitLogin();
    }
  }

  async submitLogin(e?: any) {
    const { email, password } = this.state;
    if (e && e.preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.setState({ loggingIn: true, errors: {} });
    try {
      const url = '/api/v1/users/validateLogIn';
      await request.post(url, this.state);
      this.props.navigate('/MfaVerification', { state: { email, password } });
    } catch (error) {
      if (!(error as any).message) {
        this.setState({ errors: { message: 'Error de red' }, loggingIn: false });
      } else {
        this.setState({ errors: { message: (error as any).message }, loggingIn: false });
      }
      console.log(error);
    }
  }

  async submitLoginSSO(e?: any) {
    if (e && e.preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.setState({ loggingIn: true, errors: {} });
    try {
      await window.open('/api/v1/users/azureadoauth2', '_blank');
      window.close();
      await this.props.dispatch(isUserAuthenticated());
    } catch (error) {
      if (!(error as any).message) {
        this.setState({ errors: { message: 'Error de red' }, loggingIn: false });
      } else {
        this.setState({ errors: { message: (error as any).message }, loggingIn: false });
      }
      console.log(error);
    }
  }

  handleInputChange(e: any) {
    // @ts-ignore
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const { errors } = this.state;
    const { t } = this.props;
    // 500 error responses are not formatted within input field keys
    // but rather as a message key
    let nonValidationError = '';
    if (!errors.email && !errors.password && errors.message) {
      switch (errors.message) {
        case 'Acceso denegado, utilice SSO':
          nonValidationError = t(TRANSLATIONS.ACCESS_DENIED_PLEASE_USE_SSO_LOGIN);
          break;
        case 'Low Access Level':
          nonValidationError = t(TRANSLATIONS.NOT_ENOUGH_PERMISSIONS_TO_ACCESS);
          break;
        case 'Incorrect user or password':
          nonValidationError = t(TRANSLATIONS.INCORRECT_EMAIL_PASSWORD);
          break;
        case 'denied SSO':
          nonValidationError = t(TRANSLATIONS.ACCESS_DENIED_USE_SSO);
          break;
        case 'User is Blocked':
          nonValidationError = t(TRANSLATIONS.USER_DISABLED_PLEASE_CONTACT_A_SUPERVISOR);
          break;
        case 'Multiple Failed Attempts':
          nonValidationError = t(TRANSLATIONS.TEMPORARILY_BLOCKED_BY_ATTEMPTS);
          break;
        default:
          nonValidationError = t(TRANSLATIONS.INVALID_CREDENTIALS_TRY_AGAIN);
          break;
      }
    }
    return (
      <div className="login">
        <div className="container">
          <div className="row">
            <div className="col-md-6 offset-md-3 card main-card-container">
              {/* <img style={{ width: 250 }} src={Logo} alt="logo" /> */}
              <p className="welcome-text" style={{ marginBottom: 10 }}>
                {t(TRANSLATIONS.LOGIN_TO_ACCESS_SAFETY_DASHBOARD)}
              </p>
              <form onSubmit={this.submitLogin} onKeyDown={this.enterSubmit}>
                <InputWithIcon
                  icon={UserIcon}
                  errorIcon={UserWarningIcon}
                  type="text"
                  placeholder={t(TRANSLATIONS.EMAIL)}
                  onChange={this.handleInputChange}
                  name="email"
                  error={errors.type}
                  errorHeight
                  style={{ borderWidth: '1px' }}
                  errorTxt={false}
                  autoComplete={false}
                />
                <InputWithIcon
                  icon={LockIcon}
                  errorIcon={LockIWarningIcon}
                  type="password"
                  placeholder={t(TRANSLATIONS.PASSWORD)}
                  onChange={this.handleInputChange}
                  name="password"
                  error={errors.type}
                  errorHeight
                  style={{ borderWidth: '1px' }}
                  clickable
                  errorTxt={false}
                  autoComplete={false}
                  iconRight={EyeIcon}
                  rightImageShowPassword
                />
                {nonValidationError ? <p className="loginError">{nonValidationError}</p> : null}
                <p className="recover-password-text">
                  {t(TRANSLATIONS.FORGOT_YOUR_PASSWORD)}
                  <Link
                    to="/reset-password"
                    style={{ textDecoration: 'underline' }}
                  >
                    {t(TRANSLATIONS.RECOVER_IT_HERE)}
                  </Link>
                </p>
                <HighlightButton
                  text={t(TRANSLATIONS.LOGIN).toUpperCase()}
                  className="main-action"
                  onClick={this.submitLogin}
                />
                <br />
                <ButtonWithIconAndText
                  text="SSO Login"
                  className="sso-login"
                  onClick={this.submitLoginSSO}
                  icon={MicrosoftIcon}
                />
                <p className="register-text">
                  {t(TRANSLATIONS.DONT_HAVE_AN_ACCOUNT)}?
                  <Link
                    to="/register-account"
                    style={{ textDecoration: 'underline' }}
                  >
                    {t(TRANSLATIONS.CREATE_AN_ACCOUNT)}
                  </Link>
                </p>
                {this.state.loggingIn
                  ? <LoadingSpinner text={t(TRANSLATIONS.LOGGING_IN)} className="login-spinner" />
                  : null}
              </form>
            </div>
          </div>
          <div className="row">
            <div className="footer">
              <p className="footer-text"> powered by ARVOLUTION </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    user: state.getIn(['user']).toJS(),
  };
}

export default connect(mapStateToProps)(withNavigation(withTranslation()(Login))) as any;
